import Countdown from 'react-countdown';
import './Timer.css'
import { motion } from 'motion/react'
import { useState } from 'react';

const renderer = ({ minutes, seconds, completed }) => {

    if (completed) {
        return (
            <motion.span 
                animate={{
                    scale: [1, 1.1, 1]
                }}
                transition={{
                    duration: 2,
                    repeat: Infinity
                }}
                style={{
                    color: "var(--vermelho)",
                    textTransform: 'uppercase'
                }}
            >
                Tempo esgotado!
            </motion.span>
        );
    }

    return (
        <span className="timer">
            {String(minutes).padStart(2, '0')}:
            {String(seconds).padStart(2, '0')}
        </span>
    );
};

export default function Timer({ sla, onStart, onComplete}) {

    const [timeInitial] = useState(() => Date.now() + sla * 1000);

    return (
         <Countdown
            date={timeInitial}
            renderer={renderer}
            onStart={onStart}
            onComplete={onComplete}
        />
    );
}